export default {
  name: 'transaction_settlement',
  path: 'transaction_settlement',
  component: () =>
    import(/* webpackChunkName: "transaction_settlement" */ './index.vue')
}
